import { get } from 'lodash';
import React from 'react';
import { courts } from '@upsolve/shared';

import ImageStaticMap from '../Media/ImageStaticMap';

const CourtsList = ({ district, state }) => {
  if (district == null && state == null) return null;
  return (
    <div>
      {courts
        .filter((c) => {
          if (state) return c.address.state.match(new RegExp(state, 'i'));
          if (district) return c.district.match(new RegExp(district, 'i'));
          return true;
        })
        .map((court) => (
          <div key={`${court.address.state}-${court.name}`}>
            <p>
              <b><a href={court.url}>{court.name}</a></b>
              <br />
              {court.phone}
              <br />
              {get(court, 'address.display')}
            </p>
            <ImageStaticMap
              alt={court.name}
              {...court.coordinates}
              height={200}
              width={800}
              zoom={17}
            />
          </div>
        ))}
    </div>
  );
}

export default CourtsList;
